<template>
  <div class="containerTim">
    <header-page :brand="brand"></header-page>

    <div class="top-banner mt-[82px] md:mt-[66px] relative">
      <banner-swiper :brand="brand"></banner-swiper>
    </div>

    <div id="section1" class="w-full h-1"></div>
    <form-page ref="formPageRef" :brand="brand" :carList="carList" :btn="btn" :timeAc="timeAc"></form-page>
    <footer-page :brand="brand" :phone="phone"></footer-page>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue'
import BannerSwiper from '@/components/BannerSwiper.vue'
import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'zeekrEvent',
  components: {
    HeaderPage,
    BannerSwiper,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      btn: { btnBg: '#000', btnColor: '#fff' },
      speak: '中',
      brand: {
        title: 'zeekrevent',
        name: 'zeekr',
        id: 233,
        url: 'zeekr/event',
      },
      phone: '2111 1009',
      carList: [
        { name: '9X' },
        { name: '8X' },
        { name: '7X' },
        { name: 'X' },
        { name: '009' },
        { name: '009 光輝', name_en: '009 Glory' },
        { name: '007 GT' },
      ],
      timeAc: true,
    }
  },

  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
.containerTim {
  font-family: 'Zeekr-Text-Regular', '微软雅黑' !important;
}
::v-deep .el-select-dropdown__item {
  font-family: 'Zeekr-Text-Regular', '微软雅黑' !important;
}
::v-deep .el-select-dropdown__item:hover {
  background-color: #f5f5f5;
}
::v-deep .el-select-dropdown__item.selected {
  color: #fff;
  // font-weight: 600;
  background-color: #000;
}
.top-banner {
  max-width: 1250px;
  margin: 0 auto 0;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
@media screen and (max-width: 768px) {
  .top-banner {
    max-width: 100%;
    width: 600px;
    margin: 80px auto 0;
  }
}
@media (max-width: 575px) {
  .top-banner ::v-deep .banner-swiper .swiper-container {
    height: 100% !important;
  }
}
</style>
